import { render, staticRenderFns } from "./index.vue?vue&type=template&id=71a26f21&scoped=true&lang=pug&"
import script from "./code.js?vue&type=script&lang=js&"
export * from "./code.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=less&"
import style1 from "./index.vue?vue&type=style&index=1&id=71a26f21&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a26f21",
  null
  
)

export default component.exports